/*
 * @Author: xinian
 * @Date: 2022-01-11 18:02:29
 * @LastEditors: mark
 * @LastEditTime: 2022-03-07 17:14:22
 * @FilePath: \question-bank-vue\src\utils\request.ts
 */
// request.ts
import axios from "axios";
// import { Message } from "element-ui";

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // baseURL: "/",
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 500000, // request timeout
  responseType: "json"
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // if (process.env.VUE_APP_API_MOCK == "ON") {
    //   config.baseURL = "/";
    // }
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    return res;
  },
  (error) => {
    console.log("err" + error); // for debug
    // Message({
    //   message: error.message,
    //   type: "error",
    //   duration: 5 * 1000
    // });
    return Promise.reject(error);
  }
);

export default service;
